export default "__VITE_ASSET__BuAN9Mmt__"